import {
    PorIconTrain,
    PorIconCaretdown,
    PorIconCheck,
    PorIconChevronright,
    PorIconCross,
    PorIconEmail,
    PorIconErrorMail,
    PorIconInfo,
    PorIconFavorites,
    PorIconCircleclose,
    PorIconChevronleft,
    PorIconLock,
    PorIconMagnifier,
    PorIconSpinner,
    PorIconSatellite,
    PorIconOpeninnew
} from '@por/icon-lib/icons';

// the icons required by Apex components internally - must be registered
export const ICONS_USED_BY_LIB = [
    PorIconTrain,
    PorIconCaretdown,
    PorIconCheck,
    PorIconChevronright,
    PorIconCross,
    PorIconEmail,
    PorIconErrorMail,
    PorIconInfo,
    PorIconFavorites,
    PorIconCircleclose,
    PorIconChevronleft,
    PorIconLock,
    PorIconMagnifier,
    PorIconSpinner,
    PorIconSatellite,
    PorIconOpeninnew
];
